export default __webpack_public_path__ + "static/media/img_pst_tier_gold.1f7991d8.svg";